import React from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useRecoilState, useRecoilValueLoadable } from 'recoil'

import { Select, SELECT_VARIANT_WITH_CHECKBOX } from 'mailup-web-components'

import { tagsState, searchState } from 'Pages/AbTestList/recoil/state/search'

export const InputTags = ({ onChange }) => {
  const intl = useIntl()
  const options = useRecoilValueLoadable(tagsState)
  const [{ filterTags }, setSearch] = useRecoilState(searchState)

  const handleChange = value => {
    setSearch(prev => {
      onChange(value)
      return { ...prev, filterTags: value }
    })
  }

  const selectOptions = options.state === 'hasValue' ? options.contents : []

  if (options.state === 'hasError') throw options.contents

  return (
    <Select
      multiple
      variant={SELECT_VARIANT_WITH_CHECKBOX}
      options={selectOptions}
      loading={options.state === 'loading'}
      placeholder={intl.formatMessage({ id: 'Load.TagSelector.lblSelectTags' })}
      onChange={handleChange}
      value={filterTags || []}
      data-mu-test='select--tags'
    />
  )
}

InputTags.propTypes = {
  onChange: PropTypes.func
}
